module.exports = __webpack_public_path__ + "static/index/img/baikal-500.9b8750b8.jpg";